import { Component, type ReactNode } from 'react';

const frameStyle = {
  minHeight: '100dvh',
  display: 'grid',
  placeItems: 'center',
  padding: '2rem',
  background: '#f3f9fa',
  color: '#0a2e38',
  fontFamily: 'Inter, sans-serif',
  textAlign: 'center',
} as const;

export const RouteLoadingState = () => (
  <div role="status" aria-live="polite" style={frameStyle}>
    <span>Loading CalorieScience…</span>
  </div>
);

export class RouteErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  render() {
    if (!this.state.failed) return this.props.children;

    return (
      <div role="alert" style={frameStyle}>
        <div>
          <h1 style={{ margin: '0 0 0.75rem', fontSize: '1.5rem' }}>This page couldn’t load</h1>
          <p style={{ margin: '0 0 1.5rem' }}>Refresh the page to try again.</p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{ minHeight: '48px', padding: '0.75rem 1.5rem', border: 0, borderRadius: '8px', background: '#0c7489', color: '#fff', font: 'inherit', cursor: 'pointer' }}
          >
            Refresh page
          </button>
        </div>
      </div>
    );
  }
}
